export default __webpack_public_path__ + "static/media/kitchen5-beforeA-768w.ff2707d1.webp";